// @flow

import React from 'react';
import { Flex } from '../../grid';
import ComponentColumn from '../../componentColumn';
import { getColumnsResponsiveData } from '../../row/helpers';
import type { ACFComponentColumn } from '../../../types';

type OwnProps = {|
  rows: Array<{
    columns: Array<ACFComponentColumn>,
  }>,
|};

type Props = OwnProps;

const TabContent = ({
  rows,
}: Props) => (
  <div>
    {rows.filter(row => row.columns !== false).map((row, rowIndex) => {
      const responsiveData = getColumnsResponsiveData(row.columns);

      return (
        <Flex
          key={`tabcolumn-row-${rowIndex}`} // eslint-disable-line
          width={1}
          wrap
        >
          {row.columns.map((column, colIndex) => (
            <ComponentColumn
              key={`tabcolumn-row-${rowIndex}-${colIndex}`} // eslint-disable-line
              column={column}
              cut="default"
              index={colIndex}
              responsiveData={responsiveData[colIndex]}
              rowTemplate="default"
            />
          ))}
        </Flex>
      );
    })}
  </div>
);

export default TabContent;
